<form [formGroup]="form" fxLayout="column" fxLayoutGap="30px" fxFlex="100" fxFlex.gt-sm="30" class="form-wrapper">
  <rspl-card>
    <h2 class="card-title landing" fxLayout="row">
      Landing Page
      <mat-slide-toggle
        #daySlideToggle
        labelPosition="before"
        [checked]="enabled()"
        (change)="onFormEnableToggle($event)"
      ></mat-slide-toggle>
    </h2>
    @if (isCaptain) {
      <div fxLayout="row">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Design</mat-label>
          <mat-select formControlName="version">
            @for (d of versions; track d) {
              <mat-option [value]="d.value">{{ d.text }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (splitScreenVersions.V4 === form.get('version').value) {
      <div>
        <mat-slide-toggle
          formControlName="heroVisible"
          labelPosition="before"
          [disabled]="!form.get('enabled').value"
          style="margin-bottom: 15px"
        >
          <span style="font-size: 16px; font-weight: 600">Hero content</span>
        </mat-slide-toggle>
        <div fxLayout="column">
          <h3>Logo</h3>
          <rspl-photo-upload
            fxFlex="100"
            [disabled]="!form.get('enabled').value"
            [currentImageUrl]="form.get('logo').value || charity().logo || '/assets/images/no-img-placeholder.png' | resolveUrl"
            (uploadedImageUrl)="getUploadedFileUrl($event)"
          ></rspl-photo-upload>
        </div>
        <div fxLayout="row" style="margin-bottom: 15px">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Hero title text</mat-label>
            <input
              formControlName="titlePrimary"
              matInput
              (change)="setDefaultValue($event, 'titlePrimary', 'INITIAL_TITLE_TEXT_PRIMARY')"
            />
          </mat-form-field>
        </div>
        <div fxLayout="row" style="margin-bottom: 15px">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Hero description text</mat-label>
            <textarea
              formControlName="textPrimary"
              matInput
              rows="10"
              placeholder="Free pickup facts"
              (change)="setDefaultValue($event, 'textPrimary', 'INITIAL_TEXT_PRIMARY')"
            ></textarea>
          </mat-form-field>
        </div>
        @if (isCaptain) {
          <h3>Section manager</h3>
          <div cdkDropList class="section-list" (cdkDropListDropped)="dropSection($event)">
            @for (section of form.get('sections').value; track section.type) {
              <div class="draggable-toggle-wrapper" cdkDrag cdkDragBoundary=".section-list" [cdkDragDisabled]="!form.get('enabled').value">
                @if (section.type === splitscreensectionTypes.freePickups) {
                  <div cdkDragHandle fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <mat-slide-toggle
                      class="draggable-toggle"
                      formControlName="standardEnabled"
                      labelPosition="before"
                      [disabled]="!form.get('enabled').value"
                    >
                      <span><mat-icon>drag_indicator</mat-icon></span>
                      <span>{{ section.type }}</span>
                    </mat-slide-toggle>
                    @if (this.form?.get('standardEnabled')?.value) {
                      <button type="button" mat-icon-button (click)="toggleSectionExpand(section.type)">
                        <mat-icon>{{ expandedSections().has(section.type) ? 'expand_less' : 'expand_more' }}</mat-icon>
                      </button>
                    } @else {
                      <button type="button" mat-icon-button style="visibility: hidden"><mat-icon>expand_more</mat-icon></button>
                    }
                  </div>
                  @if (this.form?.get('standardEnabled')?.value && expandedSections().has(section.type)) {
                    <div class="section-expanded-content">
                      <div fxLayout="row" style="margin-top: 15px">
                        <mat-form-field appearance="outline" fxFlex>
                          <mat-label>Title</mat-label>
                          <input matInput formControlName="title" (change)="setDefaultValue($event, 'title', 'INITIAL_TITLE_TEXT')" />
                        </mat-form-field>
                      </div>
                      <div fxLayout="row">
                        <mat-form-field appearance="outline" fxFlex>
                          <mat-label>Description</mat-label>
                          <textarea
                            matInput
                            rows="4"
                            placeholder="Free pickup facts"
                            formControlName="text"
                            (change)="setDefaultValue($event, 'text', 'INITIAL_TEXT')"
                          ></textarea>
                        </mat-form-field>
                      </div>

                      <div fxLayout="row" style="margin-bottom: 15px">
                        <mat-form-field appearance="outline" fxFlex>
                          <mat-label>Hyperlink URL</mat-label>
                          <input matInput formControlName="hyperlinkUrl" (change)="setDefaultValue($event, 'hyperlinkUrl', '')" />
                        </mat-form-field>
                      </div>
                      <div fxLayout="row" style="margin-bottom: 15px">
                        <mat-form-field appearance="outline" fxFlex>
                          <mat-label>Hyperlink display text</mat-label>
                          <input
                            matInput
                            formControlName="hyperlinkDisplayText"
                            (change)="setDefaultValue($event, 'hyperlinkDisplayText', '')"
                          />
                        </mat-form-field>
                      </div>
                      <div fxLayout="row">
                        <mat-form-field appearance="outline" fxFlex>
                          <mat-label>Link text</mat-label>
                          <input matInput formControlName="button" (change)="setDefaultValue($event, 'button', 'INITIAL_BTN_TEXT')" />
                        </mat-form-field>
                      </div>
                      <div fxLayout="row">
                        <mat-form-field appearance="outline" fxFlex>
                          <mat-label>Link URL</mat-label>
                          <input formControlName="url" matInput placeholder="http://" />
                        </mat-form-field>
                      </div>
                    </div>
                  }
                } @else if (section.type === splitscreensectionTypes.splitCard) {
                  <div cdkDragHandle fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <mat-slide-toggle
                      class="draggable-toggle"
                      labelPosition="before"
                      [disabled]="!form.get('enabled').value"
                      [checked]="section.isVisible"
                      (change)="onSectionToggle($event.checked, section.type)"
                    >
                      <span><mat-icon>drag_indicator</mat-icon></span>
                      <span>{{ section.type }}</span>
                    </mat-slide-toggle>
                    @if (section.isVisible) {
                      <button type="button" mat-icon-button (click)="toggleSectionExpand(section.type)">
                        <mat-icon>{{ expandedSections().has(section.type) ? 'expand_less' : 'expand_more' }}</mat-icon>
                      </button>
                    } @else {
                      <button type="button" mat-icon-button style="visibility: hidden"><mat-icon>expand_more</mat-icon></button>
                    }
                  </div>
                  @if (section.isVisible && expandedSections().has(section.type)) {
                    <div class="section-expanded-content">
                      <div fxLayout="row" style="margin-top: 8px">
                        <mat-form-field appearance="outline" fxFlex>
                          <mat-label>Title</mat-label>
                          <input
                            matInput
                            [value]="section.options?.title || d.title"
                            (input)="onSplitCardOptionChange('title', $any($event.target).value)"
                          />
                        </mat-form-field>
                      </div>
                      <div fxLayout="column" style="margin-bottom: 8px">
                        <label style="font-size: 12px; color: rgba(0, 0, 0, 0.6); margin-bottom: 4px">Charity logo</label>
                        <rspl-photo-upload
                          fxFlex="100"
                          [disabled]="!form.get('enabled').value"
                          [currentImageUrl]="
                            section.options?.charityLogo || charity().logo || '/assets/images/no-img-placeholder.png' | resolveUrl
                          "
                          (uploadedImageUrl)="onSplitCardOptionChange('charityLogo', $event)"
                        ></rspl-photo-upload>
                      </div>
                      <div cdkDropList class="split-card-sub-list" (cdkDropListDropped)="dropSplitCardSub($event)">
                        @for (card of getSplitCardOrder(section); track card.key) {
                          <div
                            class="draggable-toggle-wrapper"
                            cdkDrag
                            cdkDragBoundary=".split-card-sub-list"
                            [cdkDragDisabled]="!form.get('enabled').value"
                          >
                            <div cdkDragHandle fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                              <mat-slide-toggle
                                class="draggable-toggle"
                                labelPosition="before"
                                [disabled]="!form.get('enabled').value"
                                [checked]="card.visible"
                                (change)="onSplitCardSubToggle(card.visibleField, $event.checked)"
                              >
                                <span><mat-icon>drag_indicator</mat-icon></span>
                                <span>{{ card.label }}</span>
                              </mat-slide-toggle>
                              @if (card.visible) {
                                <button type="button" mat-icon-button (click)="toggleSectionExpand(card.key)">
                                  <mat-icon>{{ expandedSections().has(card.key) ? 'expand_less' : 'expand_more' }}</mat-icon>
                                </button>
                              } @else {
                                <button type="button" mat-icon-button style="visibility: hidden"><mat-icon>expand_more</mat-icon></button>
                              }
                            </div>
                            @if (card.visible && expandedSections().has(card.key)) {
                              <div fxLayout="column" style="margin-top: 8px" fxLayoutGap="8px">
                                <div fxLayout="row">
                                  <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Card title</mat-label>
                                    <input
                                      matInput
                                      [value]="card.title"
                                      (input)="onSplitCardOptionChange(card.titleField, $any($event.target).value)"
                                    />
                                  </mat-form-field>
                                </div>
                                @if (card.key === 'standard') {
                                  <div fxLayout="column" fxLayoutGap="4px">
                                    <label style="font-size: 12px; color: rgba(0, 0, 0, 0.6)">Bullets</label>
                                    @for (bullet of getStandardCardBullets(section); track $index) {
                                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px" style="align-items: center">
                                        <mat-form-field appearance="outline" fxFlex subscriptSizing="dynamic" class="bullet-field">
                                          <input
                                            matInput
                                            [value]="bullet"
                                            (input)="onStandardBulletChange($index, $any($event.target).value)"
                                          />
                                        </mat-form-field>
                                        <button type="button" mat-icon-button (click)="removeStandardBullet($index)">
                                          <mat-icon>remove</mat-icon>
                                        </button>
                                      </div>
                                    }
                                    <div style="display: flex; justify-content: flex-end">
                                      <button type="button" mat-icon-button (click)="addStandardBullet()">
                                        <mat-icon>add</mat-icon>
                                      </button>
                                    </div>
                                  </div>
                                  <div fxLayout="row">
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Button text</mat-label>
                                      <input
                                        matInput
                                        [value]="section.options?.standardCardButtonText || d.standardCardButtonText"
                                        (input)="onSplitCardOptionChange('standardCardButtonText', $any($event.target).value)"
                                      />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout="row">
                                    <mat-form-field appearance="outline" fxFlex class="button-url-field">
                                      <mat-label>Button URL</mat-label>
                                      <input
                                        matInput
                                        placeholder="http://"
                                        [value]="section.options?.standardCardButtonUrl || ''"
                                        (input)="onSplitCardOptionChange('standardCardButtonUrl', $any($event.target).value)"
                                      />
                                      <mat-hint>
                                        This value will be ignored if Standard donations feature is turned on for this charity.
                                      </mat-hint>
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout="row" fxLayoutGap="8px" style="margin-top: 40px; position: relative; z-index: 10">
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Button background</mat-label>
                                      <mat-icon
                                        matPrefix
                                        class="color-picked"
                                        style="color: {{ section.options?.standardCardButtonBg || d.standardCardButtonBg }}"
                                      >
                                        circle
                                      </mat-icon>
                                      <input
                                        matInput
                                        cpPosition="bottom"
                                        [value]="section.options?.standardCardButtonBg || d.standardCardButtonBg"
                                        [colorPicker]="section.options?.standardCardButtonBg || d.standardCardButtonBg"
                                        (colorPickerChange)="onSplitCardOptionChange('standardCardButtonBg', $event)"
                                        [cpCloseClickOutside]="true"
                                        (cpSliderDragStart)="setBodyOverflow('hidden')"
                                        (cpSliderDragEnd)="setBodyOverflow('initial')"
                                      />
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Button text color</mat-label>
                                      <mat-icon
                                        matPrefix
                                        class="color-picked"
                                        style="color: {{ section.options?.standardCardButtonColor || d.standardCardButtonColor }}"
                                      >
                                        circle
                                      </mat-icon>
                                      <input
                                        matInput
                                        cpPosition="bottom-left"
                                        [value]="section.options?.standardCardButtonColor || d.standardCardButtonColor"
                                        [colorPicker]="section.options?.standardCardButtonColor || d.standardCardButtonColor"
                                        (colorPickerChange)="onSplitCardOptionChange('standardCardButtonColor', $event)"
                                        [cpCloseClickOutside]="true"
                                        (cpSliderDragStart)="setBodyOverflow('hidden')"
                                        (cpSliderDragEnd)="setBodyOverflow('initial')"
                                      />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout="row">
                                    <mat-slide-toggle
                                      labelPosition="before"
                                      [disabled]="!form.get('enabled').value"
                                      [checked]="section.options?.standardCardHyperlink"
                                      (change)="onSplitCardSubToggle('standardCardHyperlink', $event.checked)"
                                    >
                                      Hyperlink
                                    </mat-slide-toggle>
                                  </div>
                                  @if (section.options?.standardCardHyperlink) {
                                    <div fxLayout="row">
                                      <mat-form-field appearance="outline" fxFlex>
                                        <mat-label>Text for hyperlink</mat-label>
                                        <input
                                          matInput
                                          [value]="section.options?.standardCardHyperlinkText || ''"
                                          (input)="onSplitCardOptionChange('standardCardHyperlinkText', $any($event.target).value)"
                                        />
                                      </mat-form-field>
                                    </div>
                                    <div fxLayout="row">
                                      <mat-form-field appearance="outline" fxFlex>
                                        <mat-label>Hyperlink URL</mat-label>
                                        <input
                                          matInput
                                          placeholder="http://"
                                          [value]="section.options?.standardCardHyperlinkUrl || ''"
                                          (input)="onSplitCardOptionChange('standardCardHyperlinkUrl', $any($event.target).value)"
                                        />
                                      </mat-form-field>
                                    </div>
                                  }
                                }
                                @if (card.key === 'priority') {
                                  <div fxLayout="row" style="margin-bottom: 8px">
                                    <mat-slide-toggle
                                      labelPosition="before"
                                      [disabled]="!form.get('enabled').value"
                                      [checked]="isPriorityBulletsDefault(section)"
                                      (change)="onPriorityUseDefaultToggle($event.checked)"
                                    >
                                      Use default description
                                    </mat-slide-toggle>
                                  </div>
                                  <div fxLayout="column" fxLayoutGap="4px">
                                    <label style="font-size: 12px; color: rgba(0, 0, 0, 0.6)">Bullets</label>
                                    @for (bullet of getPriorityCardBullets(section); track $index) {
                                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px" style="align-items: center">
                                        <mat-form-field appearance="outline" fxFlex subscriptSizing="dynamic" class="bullet-field">
                                          <input
                                            matInput
                                            [value]="bullet"
                                            (input)="onPriorityBulletChange($index, $any($event.target).value)"
                                          />
                                        </mat-form-field>
                                        <button type="button" mat-icon-button (click)="removePriorityBullet($index)">
                                          <mat-icon>remove</mat-icon>
                                        </button>
                                      </div>
                                    }
                                    <div style="display: flex; justify-content: flex-end">
                                      <button type="button" mat-icon-button (click)="addPriorityBullet()">
                                        <mat-icon>add</mat-icon>
                                      </button>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                } @else {
                  <div cdkDragHandle>
                    <mat-slide-toggle
                      class="draggable-toggle"
                      labelPosition="before"
                      [disabled]="!form.get('enabled').value"
                      [checked]="section.isVisible"
                      (change)="onSectionToggle($event.checked, section.type)"
                    >
                      <span><mat-icon>drag_indicator</mat-icon></span>
                      <span>{{ section.type }}</span>
                    </mat-slide-toggle>
                  </div>
                }
              </div>
            }
          </div>
        }

        @if (!isCaptain && this.form?.get('standardEnabled')?.value) {
          <h3>Free Pickup Section</h3>
          <div fxLayout="row" style="margin-bottom: 15px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Title</mat-label>
              <input matInput formControlName="title" (change)="setDefaultValue($event, 'title', 'INITIAL_TITLE_TEXT')" />
            </mat-form-field>
          </div>
          <div fxLayout="row" style="margin-bottom: 15px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Description</mat-label>
              <textarea
                matInput
                rows="10"
                placeholder="Free pickup facts"
                formControlName="text"
                (change)="setDefaultValue($event, 'text', 'INITIAL_TEXT')"
              ></textarea>
            </mat-form-field>
          </div>
          @if (isFreeSectionVisible) {
            <div fxLayout="row" style="margin-bottom: 15px">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Hyperlink URL</mat-label>
                <input matInput formControlName="hyperlinkUrl" (change)="setDefaultValue($event, 'hyperlinkUrl', '')" />
              </mat-form-field>
            </div>
            <div fxLayout="row" style="margin-bottom: 15px">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Hyperlink display text</mat-label>
                <input matInput formControlName="hyperlinkDisplayText" (change)="setDefaultValue($event, 'hyperlinkDisplayText', '')" />
              </mat-form-field>
            </div>
          }
          <div fxLayout="row">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Link text</mat-label>
              <input matInput formControlName="button" (change)="setDefaultValue($event, 'button', 'INITIAL_BTN_TEXT')" />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Link URL</mat-label>
              <input formControlName="url" matInput placeholder="http://" />
            </mat-form-field>
          </div>
        }
      </div>
    }
    @if ([splitScreenVersions.V3A, splitScreenVersions.V3B].includes(form.get('version').value)) {
      <div>
        <div fxLayout="column">
          <h3>Logo</h3>
          <rspl-photo-upload
            fxFlex="100"
            [disabled]="!form.get('enabled').value"
            [currentImageUrl]="form.get('logo').value || charity().logo || '/assets/images/no-img-placeholder.png'"
            (uploadedImageUrl)="getUploadedFileUrl($event)"
          ></rspl-photo-upload>
        </div>
        @if (isCaptain) {
          <div fxLayout="row">
            <mat-slide-toggle labelPosition="before" formControlName="discounts">Sponsorships description</mat-slide-toggle>
          </div>
        }
        <div fxLayout="row">
          <mat-slide-toggle labelPosition="before" formControlName="standardEnabled">Free Pickups</mat-slide-toggle>
        </div>
        @if (this.form?.get('standardEnabled')?.value) {
          <div fxLayout="row" style="margin-top: 15px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Free pickup process title</mat-label>
              <input formControlName="title" matInput (change)="setDefaultValue($event, 'title', 'INITIAL_TITLE_TEXT')" />
            </mat-form-field>
          </div>
          <div fxLayout="row" class="pickup-description">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Free pickup process description</mat-label>
              <textarea
                formControlName="text"
                matInput
                rows="10"
                placeholder="Free pickup facts"
                (change)="setDefaultValue($event, 'text', 'INITIAL_TEXT')"
              ></textarea>
              <mat-hint>Press enter to create bullets</mat-hint>
            </mat-form-field>
          </div>
          <div fxLayout="row" style="margin-bottom: 15px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Hyperlink URL</mat-label>
              <input matInput formControlName="hyperlinkUrl" (change)="setDefaultValue($event, 'hyperlinkUrl', '')" />
            </mat-form-field>
          </div>
          <div fxLayout="row" style="margin-bottom: 15px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Hyperlink display text</mat-label>
              <input matInput formControlName="hyperlinkDisplayText" (change)="setDefaultValue($event, 'hyperlinkDisplayText', '')" />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Free pickups/drop offs link text</mat-label>
              <input formControlName="button" matInput (change)="setDefaultValue($event, 'button', 'INITIAL_BTN_TEXT')" />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Free pickups/drop offs link URL</mat-label>
              <input formControlName="url" matInput placeholder="http://" />
            </mat-form-field>
          </div>
        }
      </div>
    }
    @if ([splitScreenVersions.V1, splitScreenVersions.V2].includes(form.get('version').value)) {
      <mat-tab-group class="split-screen-config">
        @if (isCaptain) {
          <mat-tab [disabled]="!form.get('enabled').value" label="Priority Pick-Up">
            <h3>Position</h3>
            <div fxLayout="row">
              <mat-button-toggle-group fxFlex="100" formControlName="reverse">
                <mat-button-toggle fxFlex="50" [value]="false">First (Left)</mat-button-toggle>
                <mat-button-toggle fxFlex="50" [value]="true">Second (Right)</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <h3>Title</h3>
            <div fxLayout="row">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Text</mat-label>
                <input
                  formControlName="titlePrimary"
                  matInput
                  (change)="setDefaultValue($event, 'titlePrimary', 'INITIAL_TITLE_TEXT_PRIMARY')"
                />
              </mat-form-field>
            </div>
            <div fxLayout="row" style="z-index: 17">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Background Color</mat-label>
                <mat-icon matPrefix class="color-picked" style="color: {{ form.get('titleBackgroundColorPrimary').value }}">
                  circle
                </mat-icon>
                <input
                  matInput
                  cpPosition="bottom"
                  formControlName="titleBackgroundColorPrimary"
                  [(colorPicker)]="form.get('btnBackgroundColorPrimary').value"
                  (colorPickerChange)="form.get('titleBackgroundColorPrimary').setValue($event)"
                  [cpCloseClickOutside]="true"
                  (cpSliderDragStart)="setBodyOverflow('hidden')"
                  (cpSliderDragEnd)="setBodyOverflow('initial')"
                  (change)="setDefaultValue($event, 'titleBackgroundColorPrimary', 'INITIAL_TITLE_BACKGROUND_COLOR_PRIMARY')"
                />
              </mat-form-field>
            </div>
            <div fxLayout="row" style="z-index: 16">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Text Color</mat-label>
                <mat-icon matPrefix class="color-picked" style="color: {{ form.get('btnTextColorPrimary').value }}">circle</mat-icon>
                <input
                  matInput
                  cpPosition="bottom"
                  formControlName="titleTextColorPrimary"
                  [(colorPicker)]="form.get('btnTextColorPrimary').value"
                  (colorPickerChange)="form.get('titleTextColorPrimary').setValue($event)"
                  [cpCloseClickOutside]="true"
                  (cpSliderDragStart)="setBodyOverflow('hidden')"
                  (cpSliderDragEnd)="setBodyOverflow('initial')"
                  (change)="setDefaultValue($event, 'titleTextColorPrimary', 'INITIAL_TITLE_TEXT_COLOR_PRIMARY')"
                />
              </mat-form-field>
            </div>
            <h3>Stripe</h3>
            <div fxLayout="row" style="z-index: 15">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Background</mat-label>
                <mat-icon matPrefix class="color-picked" style="color: {{ form.get('stripeBackgroundColor').value }}">circle</mat-icon>
                <input
                  formControlName="stripeBackgroundColor"
                  matInput
                  [(colorPicker)]="form.get('stripeBackgroundColor').value"
                  (colorPickerChange)="form.get('stripeBackgroundColor').setValue($event)"
                  cpPosition="bottom"
                  [cpCloseClickOutside]="true"
                  (cpSliderDragStart)="setBodyOverflow('hidden')"
                  (cpSliderDragEnd)="setBodyOverflow('initial')"
                  (change)="setDefaultValue($event, 'stripeBackgroundColor', 'INITIAL_STRIPE_BACKGROUND_COLOR')"
                />
              </mat-form-field>
            </div>
            <h3>Logo</h3>
            <div fxLayout="row" style="z-index: 14">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Background</mat-label>
                <mat-icon matPrefix class="color-picked" style="color: {{ form.get('logoBackgroundColorPrimary').value }}">circle</mat-icon>
                <input
                  formControlName="logoBackgroundColorPrimary"
                  matInput
                  [(colorPicker)]="form.get('logoBackgroundColorPrimary').value"
                  (colorPickerChange)="form.get('logoBackgroundColorPrimary').setValue($event)"
                  cpPosition="bottom"
                  [cpCloseClickOutside]="true"
                  (cpSliderDragStart)="setBodyOverflow('hidden')"
                  (cpSliderDragEnd)="setBodyOverflow('initial')"
                  (change)="setDefaultValue($event, 'logoBackgroundColorPrimary', 'INITIAL_LOGO_BACKGROUND_COLOR_PRIMARY')"
                />
              </mat-form-field>
            </div>
            <h3>Description</h3>
            <div fxLayout="row" style="margin-bottom: 15px">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Text</mat-label>
                <textarea
                  formControlName="textPrimary"
                  matInput
                  rows="10"
                  placeholder="Primary pickup facts"
                  (change)="setDefaultValue($event, 'textPrimary', 'INITIAL_TEXT_PRIMARY')"
                ></textarea>
                <mat-hint>Press enter to create bullets</mat-hint>
              </mat-form-field>
            </div>
            <div fxLayout="row" style="z-index: 13">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Background Color</mat-label>
                <mat-icon matPrefix class="color-picked" style="color: {{ form.get('backgroundColorPrimary').value }}">circle</mat-icon>
                <input
                  formControlName="backgroundColorPrimary"
                  matInput
                  [(colorPicker)]="form.get('backgroundColorPrimary').value"
                  (colorPickerChange)="form.get('backgroundColorPrimary').setValue($event)"
                  cpPosition="bottom"
                  [cpCloseClickOutside]="true"
                  (cpSliderDragStart)="setBodyOverflow('hidden')"
                  (cpSliderDragEnd)="setBodyOverflow('initial')"
                  (change)="setDefaultValue($event, 'backgroundColorPrimary', 'INITIAL_BACKGROUND_COLOR_PRIMARY')"
                />
              </mat-form-field>
            </div>
            <div fxLayout="row" style="z-index: 12">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Text Color</mat-label>
                <mat-icon matPrefix class="color-picked" style="color: {{ form.get('textColorPrimary').value }}">circle</mat-icon>
                <input
                  formControlName="textColorPrimary"
                  matInput
                  [(colorPicker)]="form.get('textColorPrimary').value"
                  (colorPickerChange)="form.get('textColorPrimary').setValue($event)"
                  cpPosition="bottom"
                  [cpCloseClickOutside]="true"
                  (cpSliderDragStart)="setBodyOverflow('hidden')"
                  (cpSliderDragEnd)="setBodyOverflow('initial')"
                  (change)="setDefaultValue($event, 'textColorPrimary', 'INITIAL_TEXT_COLOR_PRIMARY')"
                />
              </mat-form-field>
            </div>
            @if (form.get('version').value === splitScreenVersions.V1) {
              <div fxLayout="row" style="z-index: 11">
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>Bullet Color</mat-label>
                  <mat-icon matPrefix class="color-picked" style="color: {{ form.get('bulletColorPrimary').value }}">circle</mat-icon>
                  <input
                    formControlName="bulletColorPrimary"
                    matInput
                    [(colorPicker)]="form.get('bulletColorPrimary').value"
                    (colorPickerChange)="form.get('bulletColorPrimary').setValue($event)"
                    cpPosition="bottom"
                    [cpCloseClickOutside]="true"
                    (cpSliderDragStart)="setBodyOverflow('hidden')"
                    (cpSliderDragEnd)="setBodyOverflow('initial')"
                    (change)="setDefaultValue($event, 'bulletColorPrimary', 'INITIAL_BULLET_COLOR_PRIMARY')"
                  />
                </mat-form-field>
              </div>
            }
            <h3>Button</h3>
            <div fxLayout="row">
              <mat-slide-toggle labelPosition="before" formControlName="primaryReady">Ready For Use</mat-slide-toggle>
            </div>
            <div fxLayout="row">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Text</mat-label>
                <input
                  matInput
                  formControlName="buttonPrimary"
                  (change)="setDefaultValue($event, 'buttonPrimary', 'INITIAL_BTN_TEXT_PRIMARY')"
                />
              </mat-form-field>
            </div>
            <div fxLayout="row" style="z-index: 10">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Background Color</mat-label>
                <mat-icon matPrefix class="color-picked" style="color: {{ form.get('btnBackgroundColorPrimary').value }}">circle</mat-icon>
                <input
                  formControlName="btnBackgroundColorPrimary"
                  matInput
                  [(colorPicker)]="form.get('btnBackgroundColorPrimary').value"
                  (colorPickerChange)="form.get('btnBackgroundColorPrimary').setValue($event)"
                  cpPosition="top-right"
                  [cpCloseClickOutside]="true"
                  (cpSliderDragStart)="setBodyOverflow('hidden')"
                  (cpSliderDragEnd)="setBodyOverflow('initial')"
                  (change)="setDefaultValue($event, 'btnBackgroundColorPrimary', 'INITIAL_BTN_BACKGROUND_COLOR_PRIMARY')"
                />
              </mat-form-field>
            </div>
            <div fxLayout="row" style="z-index: 9">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Text Color</mat-label>
                <mat-icon matPrefix class="color-picked" style="color: {{ form.get('btnTextColorPrimary').value }}">circle</mat-icon>
                <input
                  formControlName="btnTextColorPrimary"
                  matInput
                  [(colorPicker)]="form.get('btnTextColorPrimary').value"
                  (colorPickerChange)="form.get('btnTextColorPrimary').setValue($event)"
                  cpPosition="top-right"
                  [cpCloseClickOutside]="true"
                  (cpSliderDragStart)="setBodyOverflow('hidden')"
                  (cpSliderDragEnd)="setBodyOverflow('initial')"
                  (change)="setDefaultValue($event, 'btnTextColorPrimary', 'INITIAL_BTN_TEXT_COLOR_PRIMARY')"
                />
              </mat-form-field>
            </div>
          </mat-tab>
        }
        <mat-tab [disabled]="!form.get('enabled').value" label="Standard Pick-Up">
          <div fxLayout="row">
            <mat-slide-toggle labelPosition="before" formControlName="standardEnabled">Enabled</mat-slide-toggle>
          </div>
          <h3>Title</h3>
          <div fxLayout="row">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Text</mat-label>
              <input formControlName="title" (change)="setDefaultValue($event, 'title', 'INITIAL_TITLE_TEXT')" matInput />
            </mat-form-field>
          </div>
          <div fxLayout="row" style="z-index: 8">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Background Color</mat-label>
              <mat-icon matPrefix class="color-picked" style="color: {{ form.get('titleBackgroundColor').value }}">circle</mat-icon>
              <input
                formControlName="titleBackgroundColor"
                matInput
                [(colorPicker)]="form.get('btnBackgroundColor').value"
                (colorPickerChange)="form.get('titleBackgroundColor').setValue($event)"
                [cpCloseClickOutside]="true"
                (cpSliderDragStart)="setBodyOverflow('hidden')"
                (cpSliderDragEnd)="setBodyOverflow('initial')"
                (change)="setDefaultValue($event, 'titleBackgroundColor', 'INITIAL_TITLE_BACKGROUND_COLOR')"
              />
            </mat-form-field>
          </div>
          <div fxLayout="row" style="z-index: 7">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Text Color</mat-label>
              <mat-icon matPrefix class="color-picked" style="color: {{ form.get('titleTextColor').value }}">circle</mat-icon>
              <input
                formControlName="titleTextColor"
                matInput
                [(colorPicker)]="form.get('btnTextColor').value"
                (colorPickerChange)="form.get('titleTextColor').setValue($event)"
                [cpCloseClickOutside]="true"
                (cpSliderDragStart)="setBodyOverflow('hidden')"
                (cpSliderDragEnd)="setBodyOverflow('initial')"
                (change)="setDefaultValue($event, 'titleTextColor', 'INITIAL_TITLE_TEXT_COLOR')"
              />
            </mat-form-field>
          </div>
          <h3>Logo</h3>
          <div fxLayout="row" style="z-index: 6">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Background</mat-label>
              <mat-icon matPrefix class="color-picked" style="color: {{ form.get('logoBackgroundColor').value }}">circle</mat-icon>
              <input
                formControlName="logoBackgroundColor"
                matInput
                [(colorPicker)]="form.get('logoBackgroundColor').value"
                (colorPickerChange)="form.get('logoBackgroundColor').setValue($event)"
                [cpCloseClickOutside]="true"
                (cpSliderDragStart)="setBodyOverflow('hidden')"
                (cpSliderDragEnd)="setBodyOverflow('initial')"
                (change)="setDefaultValue($event, 'logoBackgroundColor', 'INITIAL_LOGO_BACKGROUND_COLOR')"
              />
            </mat-form-field>
          </div>
          <h3>Description</h3>
          <div fxLayout="row" style="margin-bottom: 15px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Text</mat-label>
              <textarea
                formControlName="text"
                matInput
                rows="10"
                placeholder="Free pickup facts"
                (change)="setDefaultValue($event, 'text', 'INITIAL_TEXT')"
              ></textarea>
              <mat-hint>Press enter to create bullets</mat-hint>
            </mat-form-field>
          </div>
          <div fxLayout="row" style="z-index: 5">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Background Color</mat-label>
              <mat-icon matPrefix class="color-picked" style="color: {{ form.get('backgroundColor').value }}">circle</mat-icon>
              <input
                formControlName="backgroundColor"
                matInput
                [(colorPicker)]="form.get('backgroundColor').value"
                (colorPickerChange)="form.get('backgroundColor').setValue($event)"
                [cpCloseClickOutside]="true"
                (cpSliderDragStart)="setBodyOverflow('hidden')"
                (cpSliderDragEnd)="setBodyOverflow('initial')"
                (change)="setDefaultValue($event, 'backgroundColor', 'INITIAL_BACKGROUND_COLOR')"
              />
            </mat-form-field>
          </div>
          <div fxLayout="row" style="z-index: 4">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Text Color</mat-label>
              <mat-icon matPrefix class="color-picked" style="color: {{ form.get('textColor').value }}">circle</mat-icon>
              <input
                formControlName="textColor"
                matInput
                [(colorPicker)]="form.get('textColor').value"
                (colorPickerChange)="form.get('textColor').setValue($event)"
                [cpCloseClickOutside]="true"
                (cpSliderDragStart)="setBodyOverflow('hidden')"
                (cpSliderDragEnd)="setBodyOverflow('initial')"
                (change)="setDefaultValue($event, 'textColor', 'INITIAL_TEXT_COLOR')"
              />
            </mat-form-field>
          </div>
          <div fxLayout="row" style="z-index: 3">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Bullet Color</mat-label>
              <mat-icon matPrefix class="color-picked" style="color: {{ form.get('bulletColor').value }}">circle</mat-icon>
              <input
                formControlName="bulletColor"
                matInput
                [(colorPicker)]="form.get('bulletColor').value"
                (colorPickerChange)="form.get('bulletColor').setValue($event)"
                [cpCloseClickOutside]="true"
                (cpSliderDragStart)="setBodyOverflow('hidden')"
                (cpSliderDragEnd)="setBodyOverflow('initial')"
                (change)="setDefaultValue($event, 'bulletColor', 'INITIAL_BULLET_COLOR')"
              />
            </mat-form-field>
          </div>
          <h3>Button</h3>
          <div fxLayout="row">
            <mat-slide-toggle labelPosition="before" formControlName="standardReady">Ready For Use</mat-slide-toggle>
          </div>
          <div fxLayout="row">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Text</mat-label>
              <input matInput formControlName="button" (change)="setDefaultValue($event, 'button', 'INITIAL_BTN_TEXT')" />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>URL</mat-label>
              <input formControlName="url" matInput placeholder="http://" />
            </mat-form-field>
          </div>
          <div fxLayout="row" style="z-index: 2">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Background Color</mat-label>
              <mat-icon matPrefix class="color-picked" style="color: {{ form.get('btnBackgroundColor').value }}">circle</mat-icon>
              <input
                formControlName="btnBackgroundColor"
                matInput
                [(colorPicker)]="form.get('btnBackgroundColor').value"
                (colorPickerChange)="form.get('btnBackgroundColor').setValue($event)"
                [cpCloseClickOutside]="true"
                (cpSliderDragStart)="setBodyOverflow('hidden')"
                (cpSliderDragEnd)="setBodyOverflow('initial')"
                (change)="setDefaultValue($event, 'btnBackgroundColor', 'INITIAL_BTN_BACKGROUND_COLOR')"
              />
            </mat-form-field>
          </div>
          <div fxLayout="row" style="z-index: 1">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Text Color</mat-label>
              <mat-icon matPrefix class="color-picked" style="color: {{ form.get('btnTextColor').value }}">circle</mat-icon>
              <input
                formControlName="btnTextColor"
                matInput
                [(colorPicker)]="form.get('btnTextColor').value"
                (colorPickerChange)="form.get('btnTextColor').setValue($event)"
                [cpCloseClickOutside]="true"
                (cpSliderDragStart)="setBodyOverflow('hidden')"
                (cpSliderDragEnd)="setBodyOverflow('initial')"
              />
            </mat-form-field>
          </div>

          <h3>
            {{ form.get('version').value === splitScreenVersions.V1 ? 'Restricted Items' : 'Donation Guidelines' }}
            URL
          </h3>
          <div fxLayout="row">
            <mat-slide-toggle labelPosition="before" formControlName="showRestrictedItems">Show</mat-slide-toggle>
          </div>
          <div fxLayout="row">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>URL</mat-label>
              <input formControlName="restrictedItemsUrl" matInput placeholder="http://" />
            </mat-form-field>
          </div>
          @if (form.get('version').value === splitScreenVersions.V1) {
            <div fxLayout="row">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Text</mat-label>
                <input
                  formControlName="restrictedItemsText"
                  matInput
                  (change)="setDefaultValue($event, 'restrictedItemsText', 'INITIAL_RESTRICTED_ITEMS_TEXT')"
                />
              </mat-form-field>
            </div>
          }
        </mat-tab>
        <mat-tab [disabled]="!form.get('enabled').value" label="Logo">
          <ng-template matTabContent>
            <div fxFlex="100" fxLayout="column">
              <h3>Logo Configuration</h3>
              <mat-tab-group>
                <mat-tab label="Logo Image" [disabled]="!form.get('enabled').value">
                  <rspl-photo-upload
                    [disabled]="!form.get('enabled').value"
                    [currentImageUrl]="form.get('logo').value || charity().logo || '/assets/images/no-img-placeholder.png'"
                    (uploadedImageUrl)="getUploadedFileUrl($event)"
                  ></rspl-photo-upload>
                </mat-tab>
                @if (!smallWindowSizes.includes(windowSize)) {
                  <mat-tab label="Desktop Positioning" [disabled]="!form.get('enabled').value">
                    <div fxLayout="column" fxLayoutGap="10px">
                      <rspl-card cardTitle="Priority">
                        <div fxLayout="row">
                          <div fxFlex="100" fxLayout="column" fxFlexOffset="10px">
                            <div fxFlex fxLayout="column">
                              <mat-label>Size</mat-label>
                              <mat-slider
                                [disabled]="!form.get('enabled').value"
                                aria-label="Size"
                                min="-40"
                                max="40"
                                step="1"
                                tickInterval="40"
                              >
                                <input matSliderThumb name="logoSize" formControlName="logoSize" />
                              </mat-slider>
                            </div>
                            <div fxFlex fxLayout="column">
                              <mat-label>Horizontal Position</mat-label>
                              <mat-slider
                                [disabled]="!form.get('enabled').value"
                                aria-label="Left Offset"
                                min="-30"
                                max="30"
                                step="1"
                                tickInterval="30"
                              >
                                <input matSliderThumb name="logoSize" formControlName="logoOffsetLeft" />
                              </mat-slider>
                            </div>
                            <div fxFlex fxLayout="column">
                              <mat-label>Vertical Position</mat-label>
                              <mat-slider
                                [disabled]="!form.get('enabled').value"
                                aria-label="Top Offset"
                                min="-30"
                                max="30"
                                step="1"
                                tickInterval="30"
                              >
                                <input matSliderThumb name="logoSize" formControlName="logoOffsetTop" />
                              </mat-slider>
                            </div>
                          </div>
                        </div>
                      </rspl-card>
                      <rspl-card cardTitle="Standard">
                        <div fxLayout="row">
                          <div fxFlex="100" fxLayout="column" fxFlexOffset="10px">
                            <div fxFlex fxLayout="column">
                              <mat-label>Size</mat-label>
                              <mat-slider
                                [disabled]="!form.get('enabled').value"
                                aria-label="Size"
                                min="-40"
                                max="40"
                                step="1"
                                tickInterval="40"
                              >
                                <input matSliderThumb name="logoSize" formControlName="logoStandardSize" />
                              </mat-slider>
                            </div>
                            <div fxFlex fxLayout="column">
                              <mat-label>Horizontal Position</mat-label>
                              <mat-slider
                                [disabled]="!form.get('enabled').value"
                                aria-label="Left Offset"
                                min="-30"
                                max="30"
                                step="1"
                                tickInterval="30"
                              >
                                <input matSliderThumb name="logoSize" formControlName="logoStandardOffsetLeft" />
                              </mat-slider>
                            </div>
                            <div fxFlex fxLayout="column">
                              <mat-label>Vertical Position</mat-label>
                              <mat-slider
                                [disabled]="!form.get('enabled').value"
                                aria-label="Top Offset"
                                min="-30"
                                max="30"
                                step="1"
                                tickInterval="30"
                              >
                                <input matSliderThumb name="logoSize" formControlName="logoStandardOffsetTop" />
                              </mat-slider>
                            </div>
                          </div>
                        </div>
                      </rspl-card>
                    </div>
                  </mat-tab>
                }
                <mat-tab label="Mobile Positioning" [disabled]="!form.get('enabled').value">
                  <div fxLayout="column" fxLayoutGap="10px">
                    <rspl-card cardTitle="Primary">
                      <div fxLayout="row">
                        <div fxFlex="100" fxLayout="column" fxFlexOffset="10px">
                          <div fxFlex fxLayout="column">
                            <mat-label>Size</mat-label>
                            <mat-slider
                              [disabled]="!form.get('enabled').value"
                              aria-label="Size"
                              min="-40"
                              max="40"
                              step="1"
                              tickInterval="40"
                            >
                              <input matSliderThumb name="logoSize" formControlName="logoSizeMobile" />
                            </mat-slider>
                          </div>
                          <div fxFlex fxLayout="column">
                            <mat-label>Horizontal Position</mat-label>
                            <mat-slider
                              [disabled]="!form.get('enabled').value"
                              aria-label="Left Offset"
                              min="-30"
                              max="30"
                              step="1"
                              tickInterval="30"
                            >
                              <input matSliderThumb name="logoSize" formControlName="logoOffsetLeftMobile" />
                            </mat-slider>
                          </div>
                          <div fxFlex fxLayout="column">
                            <mat-label>Vertical Position</mat-label>
                            <mat-slider
                              [disabled]="!form.get('enabled').value"
                              aria-label="Top Offset"
                              min="-30"
                              max="30"
                              step="1"
                              tickInterval="30"
                            >
                              <input matSliderThumb name="logoSize" formControlName="logoOffsetTopMobile" />
                            </mat-slider>
                          </div>
                        </div>
                      </div>
                    </rspl-card>
                    <rspl-card cardTitle="Standard">
                      <div fxLayout="row">
                        <div fxFlex="100" fxLayout="column" fxFlexOffset="10px">
                          <div fxFlex fxLayout="column">
                            <mat-label>Size</mat-label>
                            <mat-slider
                              [disabled]="!form.get('enabled').value"
                              aria-label="Size"
                              min="-40"
                              max="40"
                              step="1"
                              tickInterval="40"
                            >
                              <input matSliderThumb name="logoSize" formControlName="logoStandardSizeMobile" />
                            </mat-slider>
                          </div>
                          <div fxFlex fxLayout="column">
                            <mat-label>Horizontal Position</mat-label>
                            <mat-slider
                              [disabled]="!form.get('enabled').value"
                              aria-label="Left Offset"
                              min="-30"
                              max="30"
                              step="1"
                              tickInterval="30"
                            >
                              <input matSliderThumb name="logoSize" formControlName="logoStandardOffsetLeftMobile" />
                            </mat-slider>
                          </div>
                          <div fxFlex fxLayout="column">
                            <mat-label>Vertical Position</mat-label>
                            <mat-slider
                              [disabled]="!form.get('enabled').value"
                              aria-label="Top Offset"
                              min="-30"
                              max="30"
                              step="1"
                              tickInterval="30"
                            >
                              <input matSliderThumb name="logoSize" formControlName="logoStandardOffsetTopMobile" />
                            </mat-slider>
                          </div>
                        </div>
                      </div>
                    </rspl-card>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    }
  </rspl-card>
</form>
